export default __webpack_public_path__ + "static/media/blogs-image.9de62660.jpg";